module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00032-fs8.0d4add2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00032-fs8.png
// module id = 185
// module chunks = 0